import {
  GET_DROPSHIP_DAILY_REQUEST,
  GET_DROPSHIP_DAILY_SUCCESS,
  GET_DROPSHIP_DAILY_ERROR
} from "../actions/types";

export const dropshipDaily = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_DROPSHIP_DAILY_REQUEST:
      return {
        loading: true,
      };
    case GET_DROPSHIP_DAILY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_DROPSHIP_DAILY_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
